<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-md-5">
      <!-- Encabezado con volver y título -->
      <div class="d-flex align-items-center gap-2 mb-4">
        <button class="btn btn-outline-secondary" (click)="volverAtras()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h3 class="text-primary mb-0">
          <i class="fa-solid fa-receipt me-2"></i>Registrar Nuevo Pago
        </h3>
        
      </div>
      <!-- <div *ngIf="nombreCliente" class="text-muted mb-2">
        <i class="fa-solid fa-user me-1"></i> Cliente: <strong>{{ nombreCliente }}</strong>
      </div> -->

      <!-- Indicador de carga -->
      <div *ngIf="loading" class="text-center my-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <!-- Mensajes -->
      <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
      <div *ngIf="success" class="alert alert-success">{{ success }}</div>

      <!-- Card del formulario -->
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="mb-3">
              <label for="clienteId" class="form-label fw-bold">
                <i class="fa-solid fa-user me-2"></i>Cliente
              </label>
              <select
                id="clienteId"
                class="form-select"
                formControlName="clienteId"
                [class.is-invalid]="form.get('clienteId')?.invalid && form.get('clienteId')?.touched"
              >
                <option value="">Seleccione un cliente</option>
                <option *ngFor="let cliente of clientes" [value]="cliente.clienteId">
                  {{ cliente.nombre }}
                </option>
              </select>
              <div class="invalid-feedback">Seleccione un cliente válido.</div>
            </div>

            <div class="mb-3">
              <label for="monto" class="form-label fw-bold">
                <i class="fa-solid fa-dollar-sign me-2"></i>Monto
              </label>
              <input
                type="number"
                class="form-control"
                id="monto"
                formControlName="monto"
                placeholder="Ej: 5000"
                min="0"
                step="0.01"
                required
                [class.is-invalid]="form.get('monto')?.invalid && form.get('monto')?.touched"
              />
              <div class="invalid-feedback">Ingrese un monto válido.</div>
            </div>

            <div class="d-flex gap-2 mt-4">
              <button type="submit" class="btn btn-success w-100" [disabled]="loading || form.invalid">
                <i class="fa-solid fa-check me-2"></i>
                {{ loading ? 'Registrando...' : 'Registrar Pago' }}
              </button>
              <button type="button" (click)="volverAtras()" class="btn btn-outline-secondary w-100">
                <i class="fa-solid fa-ban me-2"></i>Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

